const state = {
  immutableLists: [],
  innerLists: [],
  filterByUser: {
    apply: false,
    lastValue: null
  },
  filterBySearch: {
    apply: false,
    lastValue: null
  },
  filterByShadow: false,
  filterByLogged: false,
  filterByNoUser: false,
  filterByActivity: '',
  reaplyFilterByLogged: false,
  advancedFilter: {
    activities: [],
    autoDocumentType: [],
    tags: [],
    statusActivities: [],
    competence: null,
    dueDates: [
      {
        selected: false,
        id: 1,
        title: 'Vencidos'
      },
      {
        selected: false,
        id: 2,
        title: 'Vencem hoje'
      },
      {
        selected: false,
        id: 3,
        title: 'Vencem amanhã'
      },
      {
        selected: false,
        id: 4,
        title: 'Vencem na semana'
      },
      {
        selected: false,
        id: 5,
        title: 'Vencem nas próximas semanas'
      },
      {
        selected: false,
        id: 6,
        title: 'Sem vencimentos'
      }
    ]
  },
  selectedUserId: 0,
  triggerShadow: false,
  detachShadow: false,
  onlyShadow: false,
  search: null
  // filterControl: {
  //   triggerShadow: false,
  //   detachShadow: false,
  //   withLoggedUser: false,
  //   withoutUser: false,
  //   onlyShadows: false,
  //   filterType: 'none'
  // }
}

const getters = {
  innerLists: (state) => state.innerLists,
  immutableLists: (state) => state.immutableLists,

  hasFilterByUser: (state) => state.filterByUser.apply,
  hasFilterBySearch: (state) => state.filterBySearch.apply,
  hasFilterByShadow: (state) => state.filterByShadow,
  hasFilterByLogged: (state) => state.filterByLogged,
  hasFilterByNoUser: (state) => state.filterByNoUser,
  hasFilterByActivity: (state) => state.filterByActivity !== '',

  getLastSearch: (state) => state.filterBySearch.lastValue,
  getLastUser: (state) => state.filterByUser.lastValue,
  getFilterControl: (state) => state.filterControl,
  getActivtyFilter: (state) => state.filterByActivity,

  reaplyFilterByLogged: (state) => state.reaplyFilterByLogged,

  advancedFilter: state => state.advancedFilter,
  prepareAdvancedFilter: state => {
    return {
      activitieIds: state.advancedFilter.activities !== undefined ? state.advancedFilter.activities.map(s => s.id) : [],
      autoDocumentType: state.advancedFilter.autoDocumentType !== undefined ? state.advancedFilter.autoDocumentType.map(s => s.id) : [],
      tags: state.advancedFilter.tags.map(s => s.id),
      tagsDescription: state.advancedFilter.tags.map(s => s.description),
      dueDates: state.advancedFilter.dueDates.filter(f => f.selected === true).map(s => s.id),
      statusCheckItems: state.advancedFilter.statusActivities?.map(s => s.description),
      // search: state.search, -- Mexer
      initialDate: state.advancedFilter.competence?.startDate ? state.advancedFilter.competence.startDate : null,
      finalDate: state.advancedFilter.competence?.endDate ? state.advancedFilter.competence.endDate : null,
      selectedUserId: state.hasFilterByUser ? state.getLastUser : 0
    }
  },
  filterPagedByColumn: (state, getters) => {
    return {
      selectedUserId: state.selectedUserId,
      advancedFilter: getters.prepareAdvancedFilter,
      showTrigger: state.triggerShadow,
      showDetached: state.detachShadow,
      onlyShadows: state.filterByShadow,
      search: state.search
    }
  }
}

const actions = {
  replicateDragDropMovement ({ commit, rootState }) {
    commit('CHANGE_CARD_COLUMN', { cardConfig: rootState['listDragdrop'].dragDropObj })
  },

  startFilter ({ commit, rootState }) {
    commit('SET_BACKUP_LIST', rootState['board'].lists)
  },

  filterByUser ({ dispatch }, filter) {
    dispatch('applyFilter', { filterType: 'user', filter })
  },

  filterByTitle ({ dispatch }, filter) {
    dispatch('applyFilter', { filterType: 'search', filter })
  },

  applyFilter ({ commit, getters, rootState }, { filterType, filter }) {
    let mainMutationName = filterType === 'user' ? 'FILTER_COLUMN_BY_USER' : 'FILTER_COLUMN_BY_SEARCH'
    let othersMutationName = filterType === 'user' ? 'FILTER_COLUMN_BY_SEARCH' : 'FILTER_COLUMN_BY_USER'
    let boardLists = rootState['board'].lists
    // Refaz, pois se ja existe um filtro aplicado, não vai ser possível filtrar baseado na lista atual
    commit(mainMutationName, { from: getters.immutableLists, to: boardLists, filter })
    if ((filterType === 'user' && getters.hasFilterBySearch) || (filterType === 'search' && getters.hasFilterByUser)) {
      // Agora precisa aplicar o outro filtro, já que antes tivemos que reaplicar o filtro anterior pela lista de immutable
      let otherFilter = { listId: filter.listId }
      if (filterType === 'user') {
        otherFilter.search = getters.getLastSearch
      } else {
        otherFilter.userId = getters.getLastUser
      }
      commit(othersMutationName, { from: boardLists, to: boardLists, filter: otherFilter })
    }
  },

  applyResponsibleFilter ({ commit, dispatch, getters, rootState }, { lists }) {
    let hasFilter = !(getters.immutableLists == null || getters.immutableLists.length === 0 || (getters.immutableLists.length > 0 && !getters.immutableLists[0]))

    commit('SET_HAS_ONLYSHADOWS', false)

    dispatch('board/addLists', lists, { root: true })
    if (hasFilter) {
      commit('UPDATE_IMMUTABLE', rootState['board'].lists)
      dispatch('reaplyFilter')
    }
  },

  reaplyFilter ({ getters, dispatch }) {
    if (getters['hasFilterBySearch'] || getters['hasFilterByUser']) {
      let listIds = getters.immutableLists.map(list => list.id)
      for (let i = 0; i < listIds.length; i++) {
        if (getters['hasFilterBySearch']) {
          dispatch('applyFilter', {
            filterType: 'search',
            filter: {
              search: getters['getLastSearch'], listId: listIds[i]
            }
          })
        }
        if (getters['hasFilterByUser']) {
          dispatch('applyFilter', {
            filterType: 'user',
            filter: {
              userId: getters['getLastUser'], listId: listIds[i]
            }
          })
        }
      }
    }
  },

  applyShadows ({ commit, rootState, dispatch, getters }, { shadows, shadowType, action }) {
    let hasFilter = !(getters.immutableLists == null || getters.immutableLists.length === 0 || (getters.immutableLists.length > 0 && !getters.immutableLists[0]))
    // Quando o filtro é de somente sombras ele lida com o quadro inteiro ao invés de listas complementares
    if (shadowType === 'onlyshadow' || (getters.hasFilterByShadow && action === 'include')) {
      dispatch('board/addLists', shadows, { root: true })
      commit('SET_HAS_ONLYSHADOWS', action === 'include')

      if (hasFilter) {
        commit('UPDATE_IMMUTABLE', shadows)
        dispatch('reaplyFilter')
      }
    } else {
      // se houver filtro, precisa trabalhar com a lista de backup e a de visualização
      let immutableLists = !hasFilter ? null : getters.immutableLists

      let lists = rootState['board'].lists
      let listIds = lists.map(list => list.id)

      // Manda lista por list
      for (let i = 0; i < listIds.length; i++) {
        let id = listIds[i]
        commit('SET_SHADOWS', {
          immutableList: !immutableLists ? null : immutableLists.find(f => f.id === id),
          list: lists.find(f => f.id === id),
          shadows: !shadows ? null : shadows.find(f => f.id === id),
          shadowType,
          action
        })
        if (action === 'include' && getters.hasFilterBySearch) {
          dispatch('filterByTitle', { listId: id, search: getters.getLastSearch })
        }
      }
    }
  },

  endFilter ({ dispatch, commit, getters, rootState }, { type, listId }) {
    // Se não houver mais nada no immutableLists, significa que o filtro já foi terminado
    if (getters.immutableLists && getters.immutableLists.length > 0) {
      if (type === 'user' && getters.hasFilterBySearch) {
        commit('END_FILTER_BY_USER')
        commit('FILTER_COLUMN_BY_SEARCH', {
          from: getters.immutableLists,
          to: rootState['board'].lists,
          filter: {
            listId: listId,
            search: getters.getLastSearch
          }
        })
      } else if (type === 'search' && getters.hasFilterByUser) {
        commit('END_FILTER_BY_SEARCH')
        commit('FILTER_COLUMN_BY_USER', {
          from: getters.immutableLists,
          to: rootState['board'].lists,
          filter: {
            listId: listId,
            userId: getters.getLastUser
          }
        })
      } else { //  (!getters.hasFilterByUser && !getters.hasFilterBySearch) {
        commit('END_FILTER_BY_USER')
        commit('END_FILTER_BY_SEARCH')
        commit('END_ALL_FILTER')
        dispatch('board/addLists', getters.innerLists, { root: true })
      }
    }
  },

  clear ({ dispatch, commit }) {
    commit('END_FILTER_BY_USER')
    commit('END_FILTER_BY_SEARCH')
    commit('END_ALL_FILTER')
    // dispatch('board/addLists', getters.innerLists, { root: true })
  },
  setFilterByLogged ({ commit }, { withLoggedUser, withoutUser }) {
    commit('SET_FILTER_BY_LOGGED', { withLoggedUser, withoutUser })
  },
  setFilterByActivity ({ commit, rootState, dispatch, getters }, { activity, filteredLists }) {
    commit('SET_FILTER_BY_ACTIVITY', { activity, filteredLists })
    commit('SET_BACKUP_LIST', rootState['board'].lists)
  },

  clearAdvancedFilter ({ commit }) {
    commit('CLEAR_ADVANCED_FILTER')
  },
  setAdvancedFilter ({ commit }, filter) {
    commit('SET_ADVANCED_FILTER', filter)
  },
  setSelectedUserId ({ commit }, userId) {
    commit('SET_SELECTED_USER_ID', userId)
  },
  setShowTriggerShadow ({ commit }, show) {
    commit('SET_SHOW_TRIGGER_SHADOW', show)
  },
  setShowDetachShadow ({ commit }, show) {
    commit('SET_SHOW_DETACH_SHADOW', show)
  },
  setSearch ({ commit }, search) {
    commit('SET_SEARCH', search)
  }
}

const mutations = {

  SET_BACKUP_LIST (state, lists) {
    if (!state.immutableLists || state.immutableLists.length === 0) {
      state.immutableLists = null
      state.immutableLists = []
      lists.forEach(each => {
        let copy = { ...each }
        copy.cards = [...each.cards]
        state.immutableLists.push(copy)
      })
    }
  },

  CHANGE_CARD_COLUMN (state, { cardConfig }) {
    if (cardConfig && state.immutableLists) {
      for (let i = 0; i < state.immutableLists.length; i++) {
        let list = state.immutableLists[i]
        let cardIndex = -1
        if (list.id === Number.parseInt(cardConfig.fromList)) {
          cardIndex = list.cards.findIndex(index => index.id === cardConfig.card.id)
          list.cards.splice(cardIndex, 1)
        } else if (list.id === Number.parseInt(cardConfig.toList)) {
          list.cards.push(cardConfig.card)
        }
      }
    }
  },

  FILTER_COLUMN_BY_USER (state, { from, to, filter }) {
    state.filterByUser.lastValue = filter.userId
    state.filterByUser.apply = true
    let index = to.findIndex(index => index.id === filter.listId)
    // As listas to - from, precisam ser espelho (quanto as colunas). Senão terá que dar um findIndex na lista from tbm
    to[index].cards = from[index].cards
      .filter(filCards => filCards.shadow || filCards.users.some(some => some.id === filter.userId))
  },

  FILTER_COLUMN_BY_SEARCH (state, { from, to, filter }) {
    state.filterBySearch.lastValue = filter.search
    state.filterBySearch.apply = true
    let index = to.findIndex(index => index.id === filter.listId)
    let registerSearch = filter.search.replace(/[/\\.-]/g, '')

    let filterByTitle = from[index].cards
      .filter(fil => fil.title.toLowerCase().indexOf(filter.search.toLowerCase()) >= 0)

    let filterByCompany = from[index].cards
      .filter(fil => fil.companyName &&
                     fil.companyName.toLowerCase().indexOf(filter.search.toLowerCase()) >= 0)

    let filterByNumber = from[index].cards
      .filter(fil => fil.companyRegisterCode &&
                     fil.companyRegisterCode.indexOf(registerSearch) >= 0)

    const sortByTitle = (cardA, cardB) => {
      return cardA.title.localeCompare(cardB.title)
    }

    to[index].cards = filterByTitle.sort(sortByTitle)

    if (filterByCompany.length > 0) {
      filterByCompany.forEach(each => {
        if (!to[index].cards.includes(each)) {
          to[index].cards.push(each)
        }
      })
    }
    if (filterByNumber.length > 0) {
      filterByNumber.forEach(each => {
        if (!to[index].cards.includes(each)) {
          to[index].cards.push(each)
        }
      })
    }
  },
  SET_SHADOWS (state, { immutableList, list, shadows, shadowType, action }) {
    if (action === 'remove') {
      let lambda = null
      if (shadowType === 'detach') {
        lambda = fil => !fil.shadow || (fil.shadow && (fil.type !== 'manualfromotherboard' && fil.type !== 'fromotherboard'))
      } else if (shadowType === 'trigger') {
        lambda = fil => !fil.shadow || (fil.shadow && fil.type !== 'trigger')
      }

      // Necessário alterar a lista que é salva quando existe um search
      if (lambda) {
        list.cards = list.cards.filter(lambda)
        if (immutableList && immutableList.cards) {
          immutableList.cards = immutableList.cards.filter(lambda)
        }
      }
    } else if (action === 'include') {
      if (list.cards) {
        list.cards = list.cards.concat(shadows.cards)
      }

      // Necessário alterar a lista que é salva quando existe um search
      if (immutableList && immutableList.cards) {
        immutableList.cards = immutableList.cards.concat(shadows.cards)
      }
    }
  },

  UPDATE_IMMUTABLE (state, shadows) {
    state.immutableLists = null
    state.immutableLists = []
    // Vue.set('state', 'immutableLists', [])
    shadows.forEach(each => {
      let copy = { ...each }
      copy.cards = [...each.cards]
      state.immutableLists.push(copy)
    })
  },

  END_FILTER_BY_USER (state) {
    state.filterByUser.apply = false
    state.filterByUser.lastValue = null
  },

  END_FILTER_BY_SEARCH (state) {
    state.filterBySearch.apply = false
    state.filterBySearch.lastValue = null
  },

  END_ALL_FILTER (state) {
    if (state.immutableLists && state.immutableLists.length > 0) {
      state.innerLists = []
      state.innerLists = state.immutableLists
      for (let i = 0; i < state.immutableLists.length; i++) {
        let each = state.immutableLists[i]
        // Por algum motivo fazendo cópia aqui faz com que o objeto perca o __ob__ : Observer do Vue
        // let copy = { ...each }
        // copy.cards = [...each.cards]
        state.innerLists[i] = each
      }
      state.immutableLists = null
    }
  },
  SET_HAS_ONLYSHADOWS (state, hasOnlyShadow) {
    state.filterByActivity = ''
    state.filterByShadow = hasOnlyShadow
  },
  SET_FILTER_BY_LOGGED (state, { withLoggedUser, withoutUser }) {
    state.filterByLogged = withLoggedUser
    state.filterByNoUser = withoutUser
  },
  SET_FILTER_BY_ACTIVITY (state, { activity, filteredLists }) {
    state.filterByActivity = activity
    state.reaplyFilterByLogged = activity !== '' && state.filterBySearch.apply

    state.immutableLists = null
    state.immutableLists = []
    filteredLists.forEach(each => {
      let copy = { ...each }
      copy.cards = [...each.cards]
      state.immutableLists.push(copy)
    })
  },

  CLEAR_ADVANCED_FILTER (state) {
    state.advancedFilter.activities = []
    state.advancedFilter.tags = []
    state.advancedFilter.competence = null
    state.advancedFilter.dueDates = [
      {
        selected: false,
        id: 1,
        title: 'Vencidos'
      },
      {
        selected: false,
        id: 2,
        title: 'Vencem hoje'
      },
      {
        selected: false,
        id: 3,
        title: 'Vencem amanhã'
      },
      {
        selected: false,
        id: 4,
        title: 'Vencem na semana'
      },
      {
        selected: false,
        id: 5,
        title: 'Vencem nas próximas semanas'
      },
      {
        selected: false,
        id: 6,
        title: 'Sem vencimentos'
      }

    ]
    state.advancedFilter.statusActivities = []
  },
  SET_ADVANCED_FILTER (state, filter) {
    state.advancedFilter = filter
  },
  SET_SELECTED_USER_ID (state, userId) {
    state.selectedUserId = userId
  },
  SET_SHOW_TRIGGER_SHADOW (state, show) {
    state.triggerShadow = show
  },
  SET_SHOW_DETACH_SHADOW (state, show) {
    state.detachShadow = show
  },
  SET_SEARCH (state, search) {
    state.search = search
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
